// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__1+OBQ","modal":"modal_modal__YkF-S","slide-down":"modal_slide-down__VXr6u"};